import { render, staticRenderFns } from "./http404.vue?vue&type=template&id=13bbc456&"
import script from "./http404.vue?vue&type=script&lang=js&"
export * from "./http404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports